(function () {
  'use strict';
  var initialized = new WeakSet();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    root.querySelectorAll('[data-slideshow]').forEach(function (section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      var slides = section.querySelectorAll('[data-slide]');
      if (!slides.length) return;
      var index = 0, paused = reduced, touchX = null, touchY = null, swiped = false;
      var pause = section.querySelector('[data-pause]');
      var status = section.querySelector('[data-slide-status]');
      function label() { pause.textContent = paused ? 'Abspielen' : 'Pause'; pause.setAttribute('aria-pressed', String(paused)); }
      section.classList.add('coverflow-ready');
      function render() {
        slides.forEach(function (slide, i) {
          var offset = (i - index + slides.length) % slides.length;
          if (offset > slides.length / 2) offset -= slides.length;
          slide.hidden = false;
          slide.dataset.position = offset === 0 ? 'active' : offset === -1 ? 'previous' : offset === 1 ? 'next' : 'away';
          slide.setAttribute('aria-hidden', String(offset !== 0));
          slide.querySelectorAll('a, button').forEach(function (link) { link.tabIndex = offset === 0 ? 0 : -1; });
        });
        status.textContent = 'Artikel ' + (index + 1) + ' / ' + slides.length;
      }
      var timer = null;
      var delay = Math.max(3, Number(section.dataset.seconds) || 6) * 1000;
      function schedule() {
        clearTimeout(timer);
        if (paused || !section.isConnected || slides.length < 2) return;
        timer = setTimeout(function () {
          if (!section.isConnected) return;
          if (document.hidden || touchX !== null || section.querySelector('.slides').contains(document.activeElement)) { schedule(); return; }
          move(1);
        }, delay);
      }
      function move(delta) {
        index = (index + delta + slides.length) % slides.length;
        render();
        schedule();
      }
      render();
      section.querySelector('.slides').addEventListener('click', function (e) {
        var card = e.target.closest('[data-slide]');
        if (!card || card.dataset.position === 'active') return;
        e.preventDefault();
        move(card.dataset.position === 'previous' ? -1 : 1);
      });
      label();
      section.querySelector('[data-previous]').addEventListener('click', function () { move(-1); });
      section.querySelector('[data-next]').addEventListener('click', function () { move(1); });
      pause.addEventListener('click', function () { paused = !paused; label(); schedule(); });
      section.addEventListener('keydown', function (e) { if (/INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return; if (e.key === 'ArrowRight') { e.preventDefault(); move(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); } });
      section.addEventListener('touchstart', function (e) { clearTimeout(timer); touchX = e.changedTouches[0].clientX; touchY = e.changedTouches[0].clientY; swiped = false; }, { passive: true });
      section.addEventListener('touchend', function (e) { if (touchX === null) return; var dx = e.changedTouches[0].clientX - touchX; var dy = e.changedTouches[0].clientY - touchY; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) { swiped = true; move(dx > 0 ? -1 : 1); } touchX = null; schedule(); }, { passive: true });
      section.addEventListener('touchcancel', function () { touchX = null; swiped = false; schedule(); }, { passive: true });
      section.addEventListener('wheel', schedule, { passive: true });
      section.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopImmediatePropagation(); swiped = false; } }, true);
      schedule();
    });
    root.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (initialized.has(gallery)) return;
      initialized.add(gallery);
      var frames = gallery.querySelectorAll('.picture-frame'), index = 0;
      if (frames.length < 2 || reduced) return;
      var interval = setInterval(function () { if (!gallery.isConnected) { clearInterval(interval); return; } if (document.hidden || gallery.closest('[hidden]')) return; frames[index].hidden = true; index = (index + 1) % frames.length; frames[index].hidden = false; }, 4000);
    });
    root.querySelectorAll('[data-product]').forEach(function (section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      var selector = section.querySelector('[data-variant]');
      var button = section.querySelector('[data-add]');
      function updateVariant() {
        var option = selector.options[selector.selectedIndex];
        var chosen = option && option.value !== '';
        section.querySelector('[data-product-price]').textContent = chosen ? option.dataset.price : section.dataset.chooseLabel;
        section.querySelector('[data-product-sku]').textContent = chosen ? option.dataset.sku : '';
        button.disabled = !chosen || option.dataset.available !== 'true';
        button.textContent = !chosen ? section.dataset.chooseLabel : button.disabled ? section.dataset.soldOutLabel : section.dataset.addLabel;
        var url = new URL(window.location.href);
        if (chosen) url.searchParams.set('variant', option.value);
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.href);
      }
      if (selector) {
        selector.addEventListener('change', updateVariant);
        updateVariant();
        window.addEventListener('pageshow', updateVariant);
      }
      var text = section.querySelector('[data-personalization]');
      var placement = section.querySelector('[data-placement]');
      function validatePlacement() { if (placement && text) placement.required = text.value.trim().length > 0; }
      if (text) { text.addEventListener('input', validatePlacement); validatePlacement(); }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  var lightbox = document.querySelector('[data-lightbox]');
  if (!lightbox) return;
  var closeButton = lightbox.querySelector('[data-close-lightbox]');
  var previousFocus = null;
  function close() { lightbox.hidden = true; lightbox.querySelector('img').removeAttribute('src'); document.body.classList.remove('has-lightbox'); if (previousFocus && previousFocus.isConnected) previousFocus.focus(); }
  document.addEventListener('click', function (e) { var link = e.target.closest('[data-enlarge]'); if (!link) return; e.preventDefault(); previousFocus = link; var image = lightbox.querySelector('img'); image.src = link.href; image.alt = link.querySelector('img') ? link.querySelector('img').alt : ''; lightbox.hidden = false; document.body.classList.add('has-lightbox'); closeButton.focus(); });
  closeButton.addEventListener('click', close);
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
  document.addEventListener('keydown', function (e) { if (lightbox.hidden) return; if (e.key === 'Escape') close(); if (e.key === 'Tab') { e.preventDefault(); closeButton.focus(); } });
})();
